import { DigitalMenuDesignInterface, StyleOptionInterface } from "@/interface/business/digital-menu.interface";
import { StyleOption } from "@/modules/business/digital/index";

export default class DigitalMenuDesign implements DigitalMenuDesignInterface {
  menu_background_color: string = "";
  business_name!: StyleOptionInterface;
  basic_info!: StyleOptionInterface;
  category_name!: StyleOptionInterface;
  item_name?: StyleOptionInterface;
  modifiers?: StyleOptionInterface;
  show_modifier_list: boolean = true;
  show_item_description: boolean = true;
  show_item_image: boolean = true;
  show_local_name: boolean = true;

  constructor(data?) {
    Object.assign(this, data);
    this.menu_background_color = data?.menu_background_color || "#f4f8fc";
    this.business_name = new StyleOption(data?.business_name);
    this.basic_info = new StyleOption(data?.basic_info);
    this.category_name = new StyleOption(data?.category_name);
    this.item_name = new StyleOption(data?.item_name);
    this.modifiers = new StyleOption(data?.modifiers);
  }
}
